import { render } from "./CustomersSideBar.vue?vue&type=template&id=757146d9&scoped=true"
import script from "./CustomersSideBar.vue?vue&type=script&lang=js"
export * from "./CustomersSideBar.vue?vue&type=script&lang=js"

import "./CustomersSideBar.vue?vue&type=style&index=0&id=757146d9&lang=scss"
import "./CustomersSideBar.vue?vue&type=style&index=1&id=757146d9&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-757146d9"]])

export default __exports__